import type { AxiosInstance } from 'axios'
import { wrapApiCall } from '@/lib/axios'
import { deserialize } from 'ts-jackson'
import { Profile, UserRole, Permission } from './model'

export const AuthenticationService = (client: AxiosInstance) => {
  return {
    // Public: no auth header is sent (no signed-in user at this point). Backend
    // owns the reset email; FE no longer calls Firebase sendPasswordResetEmail.
    async forgotPassword(email: string) {
      await wrapApiCall(() => client.post('/auth/forgot-password', { email }))
    },
    async getMyProfile() {
      const { data } = await wrapApiCall(() => client.get<Record<string, unknown>>('/me/profile'))
      const { data: role } = await wrapApiCall(() =>
        client.get<Record<string, unknown>>('/me/profile/role')
      )
      const deserializeRole = deserialize(role, UserRole)
      deserializeRole.permissions = deserializeRole.permissions.map((p) =>
        deserialize(p as unknown as Record<string, unknown>, Permission)
      )
      return {
        profile: deserialize(data, Profile),
        role: deserializeRole,
      }
    },
    // Branches the signed-in user can access (QTY-1900). Not branch-scoped on
    // the backend, and sent headerless on purpose (x-skip-branch-id): the guard
    // rejects any request carrying a branch-id the user can't access, and this
    // call is what resolves the valid branch in the first place.
    async getMyBranches(): Promise<{ id: number; code: string; name: string }[]> {
      const { data } = await wrapApiCall(() =>
        client.get<{ id: number; code: string; name: string }[]>('/me/profile/branches', {
          headers: { 'x-skip-branch-id': 'true' },
        })
      )
      return data ?? []
    },
  }
}
